// extracted by mini-css-extract-plugin
export default {"account":"MyAccount__account--2tk","icon":"MyAccount__icon--1bK","welcome":"MyAccount__welcome--2L0","welcomeMessage":"MyAccount__welcomeMessage--3iR"};